import { useRef, useEffect } from 'react';
import depsEqual from 'fast-deep-equal/react';
export var useDeepEffect = function useDeepEffect(callback, deps) {
  var ref = useRef();
  if (!ref.current || !depsEqual(deps, ref.current)) ref.current = deps;
  useEffect(callback, ref.current);
};